import type {LinkProps as MaterialLinkProps, LinkTypeMap} from '@mui/material/Link';
import MaterialLink from '@mui/material/Link';
import type {OverridableComponent} from '@mui/material/OverridableComponent';
import {styled} from '@mui/material/styles';

export type LinkProps = MaterialLinkProps;

export const Link = styled(MaterialLink)(({theme}) => ({
    color: theme.tokens.FuelColorTextLink,
    textDecorationColor: theme.tokens.FuelColorTextLink,
    '&:hover': {
        color: theme.tokens.FuelColorTextLinkHovered
    },
    '&.Mui-focusVisible': {
        boxShadow: theme.tokens.FuelShadowFocused,
        outline: 'none'
    }
})) as OverridableComponent<LinkTypeMap>;
